<template>
  <div class="talent-level-container">
    <div class="list-wrap">
      <div class="block width-1 fleft">
        <router-link class="button is-success" :to="{name:'priceTagEdit'}">新增</router-link>
      </div>
      <div class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <table class="table is-bordered">
            <thead>
            <tr>
              <th>ID</th>
              <th>名称</th>
              <th>图片</th>
              <th>应用夜市名称</th>
              <th>开始时间</th>
              <th>结束时间</th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in tableData" :key="index">
              <td>{{item.priceTagId}}</td>
              <td>{{item.name}}</td>
              <td>
                <image-component :image="item.image" :width="200"></image-component>
              </td>
              <td style="min-width: 200px; max-width: 500px;">
                <button class="button is-primary marginRight"  v-for="(nightMarketName,nightMarketIndex) in item.nightMarkets" :key="nightMarketIndex">{{nightMarketName.name}}</button><br/>
              </td>
              <td>{{item.startTime}}</td>
              <td>{{item.endTime}}</td>
              <td>
                <router-link class="button is-info" :to="{name:'priceTagEdit',query:{priceTagId:item.priceTagId}}">编辑</router-link>
                <button class="button is-danger"  @click="removePriceTag(item,index)">删除</button>
              </td>
            </tr>
            </tbody>
          </table>
        </article>
      </div>
      <div class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
  export default{
    data(){
      return{
        count: 0,
        pageSize: 10,
        page: 1,
        tableData:[]
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.getPriceTagList();
      })
    },
    methods:{
      /*
      * 点击删除触发
      * */
      removePriceTag(item,index){
        if (confirm('是否确定删除?')) {
          HttpRequest.get("/admin.php?method=activity11.removePriceTag",{priceTagId:item.priceTagId},true).then((response)=>{
            if(response.data.success == 1){
              this.$message("删除成功!");
              this.tableData.splice(index,1);
            }
          })
        }
      },
      handleCurrentChange(value) {
        if(this.page !== value){
          this.page = value;
          this.getPriceTagList();
        }
      },
      getPriceTagList() {
        HttpRequest.get('/admin.php?method=activity11.getPriceTagList', {page:this.page,pageSize:this.pageSize},true).then((response) => {
          this.tableData = response.data.list;
          this.count = response.data.count;
        })
      },
    }
  }
</script>
<style lang="less" scoped>
  .list-box{
    margin-bottom: 20px;
  }
  .remark-col{
    width: 300px;
  }
  .marginRight{
    margin-right: 5px;
    margin-bottom: 5px;
  }
</style>
